export const FETCH_PERSON_ADDRESS_END = "setPersonAddress";
export const LOAD_PERSON_ADDRESS_TO_EDIT = "loadPersonAddressToEdit";
export const RESET_DEFAULT_ADDRESS_TO_EDIT = "resetDefaultAddress";
export const RESET_DEFAULT_PERSON_ADDRESS_TO_EDIT = "resetDefaultPersonAddressToEdit";
export const TOGGLE_EDIT_PERSON_ADDRESS_DIALOG = "toggleEditPersonAddressDialog";
export const TOGGLE_PERSON_ADDRESS_EDIT_STATE = "togglePersonAddressEditState";
export const UPDATE_NEW_PERSON_ADDRESS = "updateNewPersonAddress";
export const UPDATE_PERSON_ADDRESS_FIELD = "updatePersonAddressField";
